let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5LF7c")).then(() => parcelRequire('821j5'));